<script setup>
import { v4 as uuid } from 'uuid'
import { ref } from 'vue'

const props = defineProps({
  id: {
    type: String,
    default() {
      return `radio-input-${uuid()}`
    }
  },
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: null
  },
  options: {
    type: Array,
    required: true
  },
  error: {
    type: String,
    default: null
  },
  modelValue: {
    type: [String, Number, Boolean],
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const selected = ref(props.modelValue)

const optionId = (option) => {
  return `${props.id}-${option.value}`
}

const updateValue = (value) => {
  selected.value = value
  emit('update:modelValue', value)
}
</script>

<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="mt-4 space-y-2">
      <label 
        v-for="option in options" 
        :key="optionId(option)" 
        class="flex items-center"
      >
        <input
          :id="optionId(option)"
          :name="name"
          type="radio"
          :value="option.value"
          :checked="modelValue === option.value"
          :disabled="disabled"
          class="mr-2 border-gray-300 text-indigo-600 focus:ring-indigo-500"
          @change="updateValue(option.value)"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
    <div v-if="error" class="form-error text-red-500 text-sm mt-2">{{ error }}</div>
  </div>
</template>
